"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminManagersComponent = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
//INTERNAL BITS
const admin_service_1 = require("./admin.service");
const roles_service_1 = require("./roles.service");
const permission_service_1 = require("./permission.service");
const organizations_service_1 = require("./organizations.service");
const notification_service_1 = require("./notification.service");
let AdminManagersComponent = class AdminManagersComponent {
    constructor(_talk, _admin, _cd, _permission, _organizations, _roles) {
        this._talk = _talk;
        this._admin = _admin;
        this._cd = _cd;
        this._permission = _permission;
        this._organizations = _organizations;
        this._roles = _roles;
        this.searchTerm = '';
    }
    ngOnInit() {
        this.permission = this._permission.get();
        this.initManagers(0);
    }
    initManagers(selectedUser) {
        //TODO: build out for managing 360 PDMs and Connect PDMs
        this._admin.pullUsers().then(res => {
            this.users = res;
            this.organizations = this._organizations.get();
            for (var p in this.organizations) {
                this.organizations[p].selected = false;
            }
            this.selectUser(this.users[selectedUser]);
            this.mapOrganizations();
            this._cd.markForCheck();
        });
    }
    setUser(id) {
        this.users = this.users.map(u => { u.selected = u.id == id; return u; });
    }
    selectUser(user) {
        this.selectedUser = { id: user.id, email: user.email, managedOrganizations: user.managedOrganizations };
        this.setUser(user.id);
        this.mapOrganizations();
    }
    mapOrganizations() {
        this.organizations.map(o => {
            o.selected = (this.selectedUser.managedOrganizations.filter(om => {
                return om.id == o.id;
            })).length > 0;
        });
        this._cd.markForCheck();
    }
    mapOrganizationToUser() {
        //fill array with selected permissions
        var orgArray = this.organizations.reduce(function (load, org) {
            if (org.selected)
                load.push(org.id);
            return load;
        }, []);
        //call to update role
        Promise.resolve(this._admin.updateManager(this.selectedUser.id, orgArray)).then(err => {
            this._talk.broadcast(`Organizations for ` + this.selectedUser.email + ` have been updated`);
            for (let u = 0; u < this.users.length; u++) {
                if (this.users[u].id == this.selectedUser.id) {
                    this.initManagers(u);
                    break;
                }
            }
        });
    }
};
exports.AdminManagersComponent = AdminManagersComponent;
exports.AdminManagersComponent = AdminManagersComponent = __decorate([
    (0, core_1.Component)({
        selector: 'admin-managers',
        templateUrl: 'app/admin-managers.component.html',
        styleUrls: ['styles/admin.component.css'],
    }),
    (0, core_1.Injectable)(),
    __metadata("design:paramtypes", [notification_service_1.NotificationService,
        admin_service_1.AdminService,
        core_1.ChangeDetectorRef,
        permission_service_1.PermissionService,
        organizations_service_1.OrganizationsService,
        roles_service_1.RolesService])
], AdminManagersComponent);
//# sourceMappingURL=admin-managers.component.js.map